import React from 'react'
import ReactDOM from 'react-dom'
import { IntlProvider } from "react-intl"
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import EventClothes from './Screen/EventClothes/EventClothes'
import SchoolShop from './Screen/SchoolShop/SchoolShop'
import UnionClothes from './Screen/UnionClothes/UnionClothes'
import { localeData } from './locale/localeData'
import { defaultLang } from './locale'
import reportWebVitals from './reportWebVitals'
import './index.css'
import './staticContent.css'
import './tooltipStyles.css'

ReactDOM.render(
  <React.StrictMode>
    <IntlProvider locale="en" messages={localeData[defaultLang]}>
      <Router>
        <Routes>
          <Route path={`${process.env.PUBLIC_URL}/event-clothes`} element={<EventClothes />} />
          <Route path={`${process.env.PUBLIC_URL}/union-clothes`} element={<UnionClothes />} />
          <Route path={`${process.env.PUBLIC_URL}/`} element={<SchoolShop />} />
        </Routes>
      </Router>
    </IntlProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
